// extracted by css-extract-rspack-plugin
export default {"root":"now72S","user-link":"ZJAEsF","userLink":"ZJAEsF","resale-icon":"ywHdJv","resaleIcon":"ywHdJv"};